import moment from 'moment'
import Cookies from 'js-cookie'

const lang = Cookies.get('lang')
moment.locale(lang || process.env.VUE_APP_I18N_LOCALE)

export default moment
